import { Modal, Button, CloseButton } from "react-bootstrap";
import * as APIModels from "../../../models";
import FileUploader from "../FileUploader";
import { useState, useEffect, useCallback } from "react";

export type EFileModalProps = {
    show: boolean;
    courtCase: APIModels.CourtCase;
    attorneyId: string;
    attorneyName: string;
    onOk: () => void;
    onClose: () => void;
};

export default function EFileModal({
    show,
    courtCase,
    attorneyId,
    attorneyName,
    onOk,
    onClose,
}: EFileModalProps) {
    const [showManager, setShowManager] = useState(true);

    useEffect(() => {
        console.log(showManager);
    }, [showManager]);
    const onDo = () => {
        setShowManager(false);
    };
    return (
        <Modal
            show={show}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                {" "}
                <CloseButton onClick={onClose} />
            </Modal.Header>
            <Modal.Body>
                <div className="tablesaw-bar tablesaw-mode-stack">
                    <table
                        className="tablesaw table mb-0 tablesaw-stack text-center"
                        data-tablesaw-mode="stack"
                        id="table-saw-3859"
                    >
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    data-tablesaw-sortable-col=""
                                    data-tablesaw-priority="4"
                                >
                                    Case Number
                                </th>
                                <th
                                    scope="col"
                                    data-tablesaw-sortable-col=""
                                    data-tablesaw-priority="4"
                                >
                                    County
                                </th>

                                <th
                                    scope="col"
                                    data-tablesaw-sortable-col=""
                                    data-tablesaw-sortable-default-col=""
                                    data-tablesaw-priority="persist"
                                >
                                    Case Title
                                </th>
                                <th
                                    scope="col"
                                    data-tablesaw-sortable-col=""
                                    data-tablesaw-priority="2"
                                >
                                    UCN
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{courtCase.caseNumber}</td>
                                <td>{courtCase.county}</td>
                                <td>{courtCase.caseTitle}</td>
                                <td>{courtCase.ucn}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <FileUploader
                    attorneyName={attorneyName}
                    attorneyId={attorneyId}
                    ucn={courtCase.ucn!}
                ></FileUploader>
            </Modal.Body>
        </Modal>
    );
}
